<template>
  <a-modal
    :visible="visible"
    :title="modalTitle"
    width="900px"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="close">
    <!-- 搜索 -->
    <a-form layout="inline" class="table-page-search-wrapper">
      <a-form-item label="维修分类">
        <a-select
          v-model="queryParam.categoryId"
          placeholder="请选择"
          allow-clear
          show-search
          option-filter-prop="children"
          style="width: 180px"
        >
          <a-select-option v-for="d in cateList" :key="d.id">
            {{ d.categoryName }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="产品名称">
        <a-input v-model="queryParam.prodName" placeholder="请输入" allow-clear @keyup.enter="getList" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="getList">查询</a-button>
      </a-form-item>
    </a-form>

    <!-- 表格 -->
    <a-table
      rowKey="id"
      :loading="loading"
      :columns="innerColumns"
      :data-source="list"
      :row-selection="rowSelection"
      :pagination="pagination"
      :scroll="{ x: 900 }"
      style="margin-top: 16px"
      @change="handleTableChange"
    >
      <!-- 图片 -->
      <span slot="pic" slot-scope="text, record">
        <img :src="$url + (record.imgs[0] || '')" style="width: 48px; height: 48px; object-fit: cover" />
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { categoryList, fetchList } from '@/api/maintenance/classification/index.js'

export default {
  name: 'MaintenanceSelectModal',
  props: {
    visible: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
    // 添加 modalTitle 属性以便父组件传递标题
    modalTitle: { type: String, default: '选择维修分类' },
  },
  data() {
    return {
      loading: false,
      list: [],
      selectedRows: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        prodName: undefined,
        categoryId: undefined,
        status: 1,
      },
      cateList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
      },
      innerColumns: [
        {
          title: '维修分类',
          dataIndex: 'categoryName',
          // 添加 ellipsis 属性防止文本过长
          ellipsis: true,
        },
        {
          title: '产品名称',
          dataIndex: 'prodName',
          ellipsis: true,
        },
        {
          title: '产品图片',
          dataIndex: 'pic',
          scopedSlots: { customRender: 'pic' },
          align: 'center',
          width: 100,
        },
      ],
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRows.map((r) => r.id),
        onChange: this.onSelectChange,
        // 添加类型声明，确保类型安全
        type: 'checkbox',
      }
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(v) {
        if (v) {
          this.getList()
          this.getClass()
          // 深拷贝避免引用问题
          this.selectedRows = JSON.parse(JSON.stringify(this.value))
        } else {
          this.selectedRows = []
          // 重置搜索条件
          this.resetQueryParam()
        }
      },
    },
    // 监听 value 变化，确保外部数据同步
    value: {
      deep: true,
      handler(newVal) {
        if (this.visible) {
          this.selectedRows = JSON.parse(JSON.stringify(newVal))
        }
      },
    },
  },
  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRows = selectedRows
    },
    getClass() {
      categoryList().then((res) => {
        this.cateList = res.data.records || []
      }).catch(error => {
        console.error('获取分类列表失败:', error)
        this.cateList = []
      })
    },
    getList() {
      this.loading = true
      fetchList(this.queryParam)
        .then((res) => {
          if (res.data && res.data.records) {
            const records = res.data.records.map((item) => ({
              ...item,
              // 确保 imgs 是数组
              imgs: item.imgs ? (typeof item.imgs === 'string' ? JSON.parse(item.imgs) : item.imgs) : [],
            }))
            this.list = records
            this.pagination.total = res.data.total || 0
          } else {
            this.list = []
            this.pagination.total = 0
          }
        })
        .catch(error => {
          console.error('获取列表失败:', error)
          this.list = []
          this.pagination.total = 0
        })
        .finally(() => (this.loading = false))
    },
    handleTableChange(pager) {
      this.queryParam.pageNum = pager.current
      this.queryParam.pageSize = pager.pageSize
      this.pagination = { ...this.pagination, ...pager }
      this.getList()
    },
    handleOk() {
      // 确保数据格式正确
      const selectedData = this.selectedRows.map(row => ({
        id: row.id,
        categoryName: row.categoryName,
        prodName: row.prodName,
        // 可以根据需要添加其他字段
      }))

      this.$emit('input', selectedData)
      this.$emit('ok', selectedData)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
    },
    // 重置搜索条件
    resetQueryParam() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        prodName: undefined,
        categoryId: undefined,
        status: 1,
      }
      this.pagination.current = 1
    },
  },
}
</script>

<style scoped>
.table-page-search-wrapper {
  margin-bottom: 0;
}
</style>
